// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formgroup-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
.formgroup-item label {
  margin-bottom: 15px;
}
.formgroup-item textarea {
  border: none;
  background-color: #F2F2F7;
  border-radius: 10px;
  padding-left: 10px;
}
.formgroup-item input {
  padding-left: 10px;
  height: 60px;
  border: none;
  background-color: #F2F2F7;
  border-radius: 10px;
}
.formgroup-item:last-of-type input {
  padding: 10px 10px 145px 10px;
}
.formgroup-item-checkbox {
  display: flex;
  gap: 10px;
  justify-content: flex-start;
}
.formgroup-item-checkbox input {
  width: 24px;
  height: 24px;
}
.formgroup-item-checkbox a {
  text-decoration: none;
  color: black;
}
.formgroup .red-er {
  color: red;
  margin-top: 10px;
  text-decoration: none;
}
.formgroup .container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
.formgroup .container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.formgroup .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 24px;
  width: 24px;
  border: 1px solid;
}
.formgroup .checkmark.red {
  border: 1px solid red !important;
}
.formgroup .container:hover input ~ .checkmark {
  background-color: #fff;
}
.formgroup .container input:checked ~ .checkmark {
  background-color: #FCAF17;
  border: none;
}
.formgroup .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.formgroup .container input:checked ~ .checkmark:after {
  display: block;
}
.formgroup .container .checkmark:after {
  left: 9px;
  top: 4px;
  width: 7px;
  height: 13px;
  border: solid black;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
  transform: rotate(45deg);
}
.formgroup .gray-btn-clr {
  background-color: #E4E7F9 !important;
}

.modal-body iframe {
  display: none;
}
@media screen and (min-width: 1400px) {
  .modal-body iframe {
    display: block;
  }
}
.modal-body .pdf {
  display: none;
  font-size: 24px;
  font-weight: 500;
  line-height: 19px;
  padding: 0px 16px;
  display: block;
  height: 19px;
  margin-bottom: 9px;
  color: #FCAF17;
  border-radius: 40px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  margin: auto;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 100%;
}
@media screen and (min-width: 1400px) {
  .modal-body .pdf {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/ContactForm.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAAJ;AAEI;EACE,mBAAA;AAAN;AAGI;EACE,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AADN;AAII;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AAFN;AAMM;EACE,6BAAA;AAJR;AAQI;EACE,aAAA;EACA,SAAA;EACA,2BAAA;AANN;AAQM;EACE,WAAA;EACA,YAAA;AANR;AASM;EACE,qBAAA;EACA,YAAA;AAPR;AAYE;EACE,UAAA;EACA,gBAAA;EACA,qBAAA;AAVJ;AAaE;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;AAXJ;AAcE;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;AAZJ;AAeE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AAbJ;AAeI;EACE,gCAAA;AAbN;AAiBE;EACE,sBAAA;AAfJ;AAkBE;EACE,yBAAA;EACA,YAAA;AAhBJ;AAmBE;EACE,WAAA;EACA,kBAAA;EACA,aAAA;AAjBJ;AAoBE;EACE,cAAA;AAlBJ;AAqBE;EACE,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;EAGA,wBAAA;AAnBJ;AAsBE;EACE,oCAAA;AApBJ;;AA0BE;EACE,aAAA;AAvBJ;AAyBI;EAHF;IAII,cAAA;EAtBJ;AACF;AAyBE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAvBJ;AAyBI;EApBF;IAqBI,aAAA;EAtBJ;AACF","sourcesContent":[".formgroup {\n  &-item {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 20px;\n\n    label {\n      margin-bottom: 15px;\n    }\n\n    textarea {\n      border: none;\n      background-color: #F2F2F7;\n      border-radius: 10px;\n      padding-left: 10px;\n    }\n\n    input {\n      padding-left: 10px;\n      height: 60px;\n      border: none;\n      background-color: #F2F2F7;\n      border-radius: 10px;\n    }\n\n    &:last-of-type {\n      input {\n        padding: 10px 10px 145px 10px;\n      }\n    }\n\n    &-checkbox {\n      display: flex;\n      gap: 10px;\n      justify-content: flex-start;\n\n      input {\n        width: 24px;\n        height: 24px;\n      }\n\n      a {\n        text-decoration: none;\n        color: black;\n      }\n    }\n  }\n\n  .red-er {\n    color: red;\n    margin-top: 10px;\n    text-decoration: none;\n  }\n\n  .container {\n    display: block;\n    position: relative;\n    padding-left: 35px;\n    margin-bottom: 12px;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  }\n  \n  .container input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n  }\n  \n  .checkmark {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 24px;\n    width: 24px;\n    border: 1px solid;\n\n    &.red {\n      border: 1px solid red !important;\n    }\n  }\n  \n  .container:hover input ~ .checkmark {\n    background-color: #fff;\n  }\n  \n  .container input:checked ~ .checkmark {\n    background-color: #FCAF17;\n    border: none;\n  }\n  \n  .checkmark:after {\n    content: \"\";\n    position: absolute;\n    display: none;\n  }\n  \n  .container input:checked ~ .checkmark:after {\n    display: block;\n  }\n  \n  .container .checkmark:after {\n    left: 9px;\n    top: 4px;\n    width: 7px;\n    height: 13px;\n    border: solid black;\n    border-width: 0 3px 3px 0;\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n\n  .gray-btn-clr {\n    background-color:#E4E7F9 !important;\n  }\n}\n\n.modal-body {\n\n  iframe {\n    display: none;\n\n    @media screen and (min-width: 1400px) {\n      display: block;\n    }\n  }\n    \n  .pdf {\n    display: none;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 19px;\n    padding: 0px 16px;\n    display: block;\n    height: 19px;\n    margin-bottom: 9px;\n    color: #FCAF17;\n    border-radius: 40px;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    margin: auto;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    height: 100%;\n\n    @media screen and (min-width: 1400px) {\n      display: none;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
